import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { UserChip } from "@/mk2/apps/forum/components/UserChip";
import { RenderSnippetAs } from "@/mk2/apps/wiki/utils";
import { Emojify } from "@/mk2/components/Emojify";
import { astToHtml, defaultFilterAdditionalData } from "@/mk2/helpers/article_ast/filters";
import { cacheLast } from "@/mk2/helpers/cache";
import { dateLocal } from "@/mk2/helpers/timeformat";
import { BlogPostEntity, PostVisibility } from "@/mk2/schemas";

import styles from "./AlbumHeader.mscss";

interface OwnProps {
    post: BlogPostEntity;
}

type Props = OwnProps;

export default class AlbumHeader extends React.Component<Props> {
    private astToHtmlCache = cacheLast(true);

    public render() {
        const { post } = this.props;

        if (!post) {
            return null;
        }

        // prepare album header body
        let bodyChunks: React.ReactChild[] = null;

        if (post.perexAST) {
            const additionalData = {
                ...defaultFilterAdditionalData,
                linkedObjects: post.perexASTAdditionalData
                    ? post.perexASTAdditionalData.linkedObjects
                    : {},
                renderSpecialWikiLinks: false,
                renderSnippetObjectsAs: RenderSnippetAs.HTML_LINK,
                rootDiv: false,
            };
            bodyChunks = this.astToHtmlCache(
                () => astToHtml(post.perexAST, additionalData),
                post.perexAST,
            );
        }

        return (
            <div className={styles.AlbumHeader}>
                <div className={styles.AlbumHeader__meta}>
                    <UserChip user={post.author} size={24} boldUsername alignOnBaseline />

                    <div className={styles.AlbumHeader__metaDate}>{dateLocal(post.created)}</div>

                    {post.visibility !== PostVisibility.Public && (
                        <div className={styles.AlbumHeader__metaVisibility}>
                            <FontAwesomeIcon icon={faLock} />
                        </div>
                    )}
                </div>

                <h1 className={styles.AlbumHeader__title}>
                    <Emojify size={26}>{bodyChunks}</Emojify>
                </h1>
            </div>
        );
    }
}
